export class Talk {
  id: number;
  user_id: number;
  free_text: string;
  image_url: string;
  stamp_id: number;
  created_at: Date;
  read_at: Date;
  content: string;

  // extra
  system: boolean;
  need_input_cast_request_location: boolean;
  title: string;
  consume_point: number;
  node: string;
  is_thanks_message: boolean;

  constructor(fields: any) {
    for (const f in fields) {
      this[f] = fields[f];
    }
  }

  getCreatedAt(): Date {
    return new Date(this.created_at);
  }

  isSystemTalk(): boolean {
    return this.system;
  }

  isPatoTalk(): boolean {
    return !this.isSystemTalk() && this.getUserId() === 0;
  }

  isThanksMessage(): boolean {
    return this.is_thanks_message;
  }

  getUserId(): number {
    return this.user_id;
  }

  getFreeText(): string {
    return this.free_text;
  }
  hasFreeText(): boolean {
    return !!this.free_text;
  }

  hasImage(): boolean {
    return !!this.image_url && this.image_url != "";
  }

  getImageUrl(): string {
    return this.image_url;
  }

  hasLikeStamp(): boolean {
    return this.stamp_id == 1 || this.stamp_id == 2 || this.stamp_id == 3;
  }

  hasRichLikeStamp(): boolean {
    return this.stamp_id === 5;
  }

  hasChocolateStamp(): boolean {
    return this.stamp_id === 6;
  }

  hasWhiteChocolateStamp(): boolean {
    return this.stamp_id === 7;
  }

  hasOnedariChocolateStamp(): boolean {
    return this.stamp_id === 8;
  }

  getLikeStampImageUrl(): string {
    return "assets/img/stamp/like.png";
  }

  getRichLikeStampImageUrl(): string {
    return "assets/img/stamp/rich-like.png";
  }

  getChocolateStampImageUrl(): string {
    return "assets/img/stamp/chocolate.png";
  }

  getWhiteChocolateStampImageUrl(): string {
    return "assets/img/stamp/white-chocolate.png";
  }

  getOnedariChocolateStampImageUrl(): string {
    return "assets/img/stamp/onedari-chocolate.png";
  }

  readedString(): string {
    return this.read_at ? "既読" : "";
  }
}



// WEBPACK FOOTER //
// ./src/models/talk.ts